<template>
  <v-layout fill-height align-center>
    <v-row>
      <v-col cols="10" md="6" lg="3" :class="'offset-1 offset-md-3 offset-lg-' + this.layoutDirection">
        <v-card class="elevation-12 login-card" light>
          <v-card-title class="primary--text justify-center">{{ projectTitle }}</v-card-title>
          <ValidationObserver ref="observerLogin">
            <v-form ref="form" @submit="handleLogin">
              <v-card-actions >
                <v-spacer v-show="showOauthLogin"></v-spacer>
                <v-btn v-show="showOauthLogin" :to="{ name: 'Login', query: { a: 'oauth_pkce' } }" color="primary" type="submit" depressed right large>
                  {{ this.loginOauthLoginButtonText }}
                </v-btn>
                <v-spacer v-show="showGovBrOauthLogin"></v-spacer>
                <v-btn v-show="showGovBrOauthLogin" :to="{ name: 'Login', query: { a: 'gov_br' } }" color="primary" type="submit" depressed right large >
                  {{ this.loginGovBrOauthLoginButtonText }}
                </v-btn>
                <v-spacer v-show="showGovBrOauthLogin"></v-spacer>
                <a :href="urlGovBr">GOV.BR</a>
              </v-card-actions>
              <v-card-text>
                <ValidationProvider :name="$vuetify.lang.t('$vuetify.auth.email')" rules="required|email" v-slot="{ errors }">
                  <VAppTextField
                    v-model="authObj.email"
                    name="email"
                    prepend-inner-icon="mdi-account"
                    :label="$vuetify.lang.t('$vuetify.auth.email')"
                    :error-messages="errors"
                  ></VAppTextField>
                </ValidationProvider>
                <ValidationProvider :name="$vuetify.lang.t('$vuetify.auth.password')" rules="required" v-slot="{ errors }">
                  <VAppTextField
                    v-model="authObj.password"
                    type="password"
                    name="password"
                    prepend-inner-icon="mdi-lock"
                    :label="$vuetify.lang.t('$vuetify.auth.password')"
                    :error-messages="errors"
                  ></VAppTextField>
                </ValidationProvider>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" type="submit" depressed right large>
                  {{ $vuetify.lang.t("$vuetify.buttons.login") }}
                </v-btn>
              </v-card-actions>
            </v-form>
          </ValidationObserver>
        </v-card>
      </v-col>
    </v-row>
  </v-layout>
</template>

<script>
import authenticationApi from "@/api/authentication";
import parameterConfigurationApi from "@/api/parameterConfiguration";
import { enumContentConfiguration } from "@/enums/configurationKeys";
import parameterConfiguration from "@/api/parameterConfiguration";

export default {
  name: "Login",
  components: {},
  metaInfo: {
    title: "Login Alternativo",
  },
  data: () => ({
    authObj: {
      email: "",
      password: "",
      remember: false,
    },
    oauthObj: {
      codeVerifier: "",
      codeChallenge: "",
    },
    projectTitle: "",
    layoutDirection: "8",
    loginOauthLoginButtonEnabled: "false",
    loginOauthLoginButtonText: "Login",
    loginGovBrOauthLoginButtonEnabled: "false",
    loginGovBrOauthLoginButtonText: "Login",
    loginGovBrOauthClientID: "",
    loginGovBrOauthScope: "openid+email+profile",
    loginGovBrOauthRedirectUri: "",
  }),
  computed: {
    showOauthLogin() {
      var oauthpkce = localStorage.getItem("oauthpkceParameter");
      if (oauthpkce == "true" && this.loginOauthLoginButtonEnabled == "true") {
        return true;
      }
      return false;
    },
    showGovBrOauthLogin() {
      var oauthpkce = localStorage.getItem("oauthpkceParameter");
      if (oauthpkce == "true" && this.loginGovBrOauthLoginButtonEnabled == "true") {
        return true;
      }
      return false;
    },
    urlGovBr() {
      return this.getOAuthURL();
    },
  },
  async created() {
    this.getLayoutDirection();
    this.getOAuthLoginParameters();
    this.getGovBrOAuthLoginParameters();
    this.getAppParameters();
  },
  methods: {
    // Login function
    handleLogin(e) {
      // Prevent default action
      e.preventDefault();
      // Show Overlay
      this.$emit("control-overlay", true);
      // validate form
      this.$refs.observerLogin.validate().then((success) => {
        if (success) {
          authenticationApi
            .authenticate(this.authObj)
            .then(() => {
              // Hide Overlay
              this.$emit("control-overlay", false);
              // Redirect User to Dashboard
              this.$router.push({ name: "Dashboard" });
            })
            .catch((error) => {
              this.$notify({
                group: "application",
                type: "error",
                title: this.$vuetify.lang.t("$vuetify.api.authentication.errors.authenticate"),
                text: error.message,
              });
            })
            .finally(() => {
              // Hide Overlay
              this.$emit("control-overlay", false);
            });
        } else {
          this.$notify({
            group: "application",
            type: "error",
            title: this.$vuetify.lang.t("$vuetify.auth.notifications.errors.formObserverLogin.title"),
            text: this.$vuetify.lang.t("$vuetify.auth.notifications.errors.formObserverLogin.message"),
          });
          // Hide Overlay
          this.$emit("control-overlay", false);
        }
      });
    },
    getLayoutDirection() {
      parameterConfiguration.getLayoutDirection().then((response) => {
        if (response.toUpperCase() == "LEFT") this.layoutDirection = 1;
        if (response.toUpperCase() == "CENTER") this.layoutDirection = 5;
        if (response.toUpperCase() == "RIGHT") this.layoutDirection = 8;
      });
    },
    async getAppParameters() {
      await parameterConfigurationApi
        .get()
        .then(async (configurationItems) => {
          // Set new colors configuration
          await Promise.all(
            configurationItems.map(async (element) => {
              if (element.code === enumContentConfiguration.VUEAPPTITLE && element.value) this.projectTitle = element.value;
            })
          );
        })
        .catch((error) => {
          this.$notify({
            group: "application",
            type: "error",
            title: this.$vuetify.lang.t("$vuetify.api.layoutConfiguration.errors.get"),
            text: error.message,
          });
        });
    },
    getOAuthLoginParameters() {
      parameterConfiguration.getOauthpkceLoginButtonEnabled().then((response) => {
        this.loginOauthLoginButtonEnabled = response ? "true" : "false";
      });

      parameterConfiguration.getOauthpkceLoginButtonText().then((response) => {
        this.loginOauthLoginButtonText = response;
      });
    },
    getGovBrOAuthLoginParameters() {
      parameterConfiguration.getGovBrOauthpkceLoginButtonEnabled().then((response) => {
        this.loginGovBrOauthLoginButtonEnabled = response ? "true" : "false";
      });

      parameterConfiguration.getGovBrOauthpkceLoginButtonText().then((response) => {
        this.loginGovBrOauthLoginButtonText = response;
      });

      parameterConfiguration.getGovBrOauthpkceAuthorizeURL().then((response) => {
        this.loginGovBrOauthAuthorizeURL = response;
      });

      parameterConfiguration.getGovBrOauthpkceClientId().then((response) => {
        this.loginGovBrOauthClientID = response;
      });

      parameterConfiguration.getGovBrOauthpkceScope().then((response) => {
        this.loginGovBrOauthScope = response;
      });

      parameterConfiguration.getGovBrOauthpkceRedirectUri().then((response) => {
        this.loginGovBrOauthRedirectUri = response;
      });
    },
    getOAuthURL() {
      if (this.loginGovBrOauthAuthorizeURL === "") return;

      localStorage.setItem("authenticationType", "GOV_BR");

      // Show Overlay
      this.oauthObj.codeVerifier = this.generateCodeVerifier();
      localStorage.setItem("oauthpkce", this.oauthObj.codeVerifier);
      this.oauthObj.codeChallenge = this.generateCodeChallenge();

      let redirectUri = this.loginGovBrOauthRedirectUri !== "" ? this.loginGovBrOauthRedirectUri : location.origin + "/oauthpkce";

      let authorizeURL = `${this.loginGovBrOauthAuthorizeURL}?
client_id=${this.loginGovBrOauthClientID}&
redirect_uri=${redirectUri}&
response_type=code&
scope=${this.loginGovBrOauthScope}&
state=UQCZRlSlLSu13jS2&
code_challenge=${this.oauthObj.codeChallenge}&
code_challenge_method=S256`;

      return authorizeURL;
    },
    generateCodeVerifier() {
      var text = "";
      var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~";
      for (var i = 0; i < 128; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
      }
      return text;
    },
    generateCodeChallenge() {
      var code_challenge = this.CryptoJS.SHA256(this.oauthObj.codeVerifier);
      code_challenge = code_challenge.toString(this.CryptoJS.enc.Base64).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
      return code_challenge;
    },
  },
};
</script>
